export const PAGE_GUTTER = "8vw";


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/consts.ts